export default __webpack_public_path__ + "static/placeholderReviews-358fddcc37e4718a55323b757af9d504.webp";